export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/hit.8a4aeb8c.svg","height":165,"width":165,"blurWidth":0,"blurHeight":0};